import { comparison, adFreeHighlights } from "@/mocks/homeData";

export default function AdFreeSection() {
  return (
    <section id="adfree" className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="text-xs md:text-sm font-label tracking-[0.2em] text-primary-400 uppercase">
            Ad-free Experience
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-background-50">
            无广告版体验，更干净的观看与阅读
          </h2>
          <p className="mt-3 text-sm md:text-base text-background-200 leading-relaxed">
            无广告版去掉了页面推广位与浮动条，资源优先直出，打开速度更轻快。
            它同样是免费的，只是把注意力还给你和内容本身。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {adFreeHighlights.map((h) => (
            <div
              key={h.title}
              className="rounded-lg border border-background-50/15 bg-background-50/5 p-5"
            >
              <span className="w-11 h-11 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xl">
                <i className={h.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-background-50">{h.title}</h3>
              <p className="mt-2 text-xs text-background-200/85 leading-relaxed">{h.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-9 overflow-hidden rounded-lg border border-background-50/15">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[560px] text-left">
              <thead>
                <tr className="bg-background-50/10">
                  {comparison.headers.map((h, i) => (
                    <th
                      key={h}
                      className={`px-4 md:px-6 py-3.5 font-label text-xs md:text-sm whitespace-nowrap ${
                        i === 2 ? "text-primary-300" : "text-background-100"
                      }`}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {comparison.rows.map((row, idx) => (
                  <tr
                    key={row.item}
                    className={idx % 2 === 1 ? "bg-background-50/5" : ""}
                  >
                    <td className="px-4 md:px-6 py-3.5 text-xs md:text-sm text-background-50 whitespace-nowrap">
                      {row.item}
                    </td>
                    <td className="px-4 md:px-6 py-3.5 text-xs md:text-sm text-background-200/80">
                      {row.normal}
                    </td>
                    <td className="px-4 md:px-6 py-3.5 text-xs md:text-sm text-primary-300 font-medium">
                      <span className="inline-flex items-center gap-1.5">
                        <i className="ri-check-double-line" aria-hidden="true"></i>
                        {row.clean}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}